import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-accent-500">韩漫大全</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              最新最全的正版韩国漫画在线阅读平台，每日更新，高清画质，为您带来流畅舒适的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">分类浏览</h4>
            <ul className="space-y-2">
              {categories.map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><a href="/about#contact" className="text-sm text-background-300 hover:text-accent-400 transition-colors">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">免责声明</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              本站所有漫画内容均来自正版授权渠道，仅供在线阅读。未经授权，禁止转载、复制或用于商业用途。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">© 2024 韩漫大全. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors" aria-label="微博" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line" /></div>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors" aria-label="微信" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line" /></div>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors" aria-label="B站" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-bilibili-line" /></div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}